import {
  buildRedditPostUrl,
  parseRedditSourceId,
} from "../../application/sources/reddit-source-id";
import type { DiscoverNoteSource } from "../shared/source-contract";

export function RedditNoteSourceCard({ note }: { note: DiscoverNoteSource }) {
  const redditSource = parseRedditSourceId({ sourceId: note.sourceId });
  if (!redditSource) {
    return null;
  }

  return (
    <div className="space-y-2">
      <p className="text-[0.85rem] text-[var(--explore-text-secondary)]">
        Reddit post in r/{redditSource.subreddit}
      </p>
      <a
        className="text-[0.85rem] text-[var(--explore-accent-teal)] underline underline-offset-4"
        href={
          note.url ??
          buildRedditPostUrl({
            subreddit: redditSource.subreddit,
            postId: redditSource.postId,
          })
        }
        rel="noreferrer noopener"
        target="_blank"
      >
        {note.title ?? "Open Reddit thread"}
      </a>
    </div>
  );
}
